var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"s-chip",class:_vm.size ? `is_${_vm.size}` : '',style:(_vm.chipStyle)},[_c('span',{staticClass:"s-chip__content",style:(_vm.contentStyle)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }